import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { EditZonaGeograficaComponent } from './dialogs/edit/edit.component';
import { ZoneGeograficheComponent } from './zone-geografiche.component';



@NgModule({
  declarations: [ZoneGeograficheComponent,
    EditZonaGeograficaComponent,],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ResourcefulIndexModule,
    CustomFormControlsModule,
  ],
  exports: [ZoneGeograficheComponent,
    EditZonaGeograficaComponent,]
})
export class ZoneGeograficheModule { }
